import React from "react";

const School = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15.9984V10.0984L12.95 14.4734C12.65 14.6401 12.3333 14.7234 12 14.7234C11.6666 14.7234 11.35 14.6401 11.05 14.4734L2.59998 9.87344C2.41664 9.77344 2.28748 9.64844 2.21248 9.49844C2.13748 9.34844 2.09998 9.18177 2.09998 8.99844C2.09998 8.8151 2.13748 8.64844 2.21248 8.49844C2.28748 8.34844 2.41664 8.22344 2.59998 8.12344L11.05 3.52344C11.2 3.4401 11.3541 3.3776 11.5125 3.33594C11.6708 3.29427 11.8333 3.27344 12 3.27344C12.1666 3.27344 12.3291 3.29427 12.4875 3.33594C12.6458 3.3776 12.8 3.4401 12.95 3.52344L22.475 8.72344C22.6416 8.80677 22.7708 8.9276 22.8625 9.08594C22.9541 9.24427 23 9.4151 23 9.59844V15.9984C23 16.2818 22.9041 16.5193 22.7125 16.7109C22.5208 16.9026 22.2833 16.9984 22 16.9984C21.7166 16.9984 21.4791 16.9026 21.2875 16.7109C21.0958 16.5193 21 16.2818 21 15.9984Z"
        fill="#3D68FF"
      />
      <path
        d="M11.05 20.4742L6.05 17.7742C5.71667 17.5909 5.45833 17.3409 5.275 17.0242C5.09167 16.7076 5 16.3659 5 15.9992V12.1992L11.05 15.4742C11.35 15.6409 11.6667 15.7242 12 15.7242C12.3333 15.7242 12.65 15.6409 12.95 15.4742L19 12.1992V15.9992C19 16.3659 18.9083 16.7076 18.725 17.0242C18.5417 17.3409 18.2833 17.5909 17.95 17.7742L12.95 20.4742C12.8 20.5576 12.6458 20.6201 12.4875 20.6617C12.3292 20.7034 12.1667 20.7242 12 20.7242C11.8333 20.7242 11.6708 20.7034 11.5125 20.6617C11.3542 20.6201 11.2 20.5576 11.05 20.4742Z"
        fill="#3055D4"
      />
    </svg>
  );
};

export default School;
